import { MILLISECONDS } from '@chiroup/core/constants/time';
import { use } from 'react';
import { useQuery } from 'react-query';
import { CustomizationListItem } from '../components/clinical-skills/CustomizationListItem.type';
import { MeContext } from '../contexts/me.context';
import { useSandboxClinicalData } from '../contexts/sandboxClinicalData.context';
import supplementService from '../services/supplement.service';

type Props = {
  refetchOnMount?: boolean;
  omitOnline?: boolean;
  ids?: number[];
  enabled?: boolean;
  getReferenceCodes?: boolean;
};

const useSupplements = ({
  refetchOnMount = true,
  omitOnline = false,
  ids = [],
  enabled = true,
  getReferenceCodes = false,
}: Props = {}) => {
  const sandbox = useSandboxClinicalData();
  const meContext = use(MeContext);
  const { data, isFetching } = useQuery<{
    data: CustomizationListItem[];
    itemTaxHash: { [key: string]: boolean };
  }>(
    ['supplements', ids],
    () =>
      sandbox
        ? { data: [], itemTaxHash: {} }
        : supplementService.list(
            meContext.me.selectedClinic?.ID || -1,
            omitOnline,
            getReferenceCodes,
            ids
          ),
    {
      refetchOnWindowFocus: false,
      refetchOnMount,
      enabled,
      staleTime: MILLISECONDS.inMinutes(10),
    }
  );

  return { isFetching, data };
};

export default useSupplements;
